import Vapi from "vuex-rest-api"
import Booking from "@/components/Booking/models/Booking"
import AppEvents from '@/AppEvents';
import IPriceEstimate from '../models/IPriceEstimate';

const bookingApi = new Vapi({
    baseURL: process.env.VUE_APP_API_HOST + "/api/booking",
    state: {
        bookings: [],
        bookingPriceEstimate: null,
        selectedBooking: 0
    }
})
    .get({
        action: "getDestinationBookings",
        property: "bookings",
        path: ({ destinationId }) => ("/destination/" + destinationId),
        onSuccess: (state, payload, axios) => {
            // console.log("getDestinationBookings onSuccess", state, payload.data);
            const apiBookings: any[] = payload.data;
            apiBookings.forEach((apiBooking: any) => {
                const newBooking =  Booking.fromApiBookingDetailsViewModel(apiBooking, );
                const index: number = state.bookings.findIndex(t => t.id === newBooking.id);
                if (index > -1){
                    // booking already exists, update props
                    Object.assign(state.bookings[index], newBooking);
                } else {
                    // booking does not exists, push it to the store
                    state.bookings.push(newBooking);
                }
            });
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .get({
        action: "getBookingById",
        property: "booking",
        path: ({ destinationId, id }) => ("/destination/" + destinationId + "/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("updateBooking onSuccess", state, payload.data);
            const booking = Booking.fromApiBookingDetailsViewModel(payload.data);
            const bookingIndex = state.bookings.findIndex(p => p.id === booking.id);
            if (bookingIndex > -1) {
                // Booking already exists, update props
                Object.assign(state.bookings[bookingIndex], booking);
            } else {
                // Booking does not exist, push it to state.bookings
                state.bookings.push(booking);
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "getPriceEstimate",
        property: "estimate",
        path: ({ destinationId }) => ("/destination/" + destinationId + "/getEstimate"),
        onSuccess: (state, payload, axios) => {
            // console.log("getEstimate onSuccess", state, payload.data);
            const estimate: IPriceEstimate = payload.data;
            state.bookingPriceEstimate = estimate
            // console.log("state.bookingPriceEstimate is now:", state.bookingPriceEstimate);
            return estimate;
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "createBooking",
        property: "booking",
        path: ({ destinationId }) => ("/destination/" + destinationId),
        onSuccess: (state, payload, axios) => {
            // console.log("createBooking onSuccess", state, payload.data);
            const booking = Booking.fromApiBookingDetailsViewModel(payload.data);
            state.bookings.push(booking);
            // console.log("state.bookings is now:", state.bookings);
            return booking;
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .put({
        action: "updateBooking",
        property: "booking",
        path: ({ destinationId }) => ("/destination/" + destinationId),
        onSuccess: (state, payload, axios) => {
            // console.log("updateBooking onSuccess", state, payload.data);
            const booking = Booking.fromApiBookingDetailsViewModel(payload.data);
            const bookingIndex = state.bookings.findIndex(p => p.id === booking.id);
            // Booking already exists, update props
            if (bookingIndex > -1){
                Object.assign(state.bookings[bookingIndex], booking);
            } else {
                console.error("Failed to update local booking after response from API to an update request");
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .delete({
        action: "deleteBooking",
        property: "booking",
        path: ({ destinationId, id }) => ("/destination/" + destinationId + "/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("deleteBooking onSuccess", state, payload.data);
            const booking = Booking.fromApiBookingDetailsViewModel(payload.data);
            const bookingIndex = state.bookings.findIndex(p => p.id === booking.id);
            // Booking already exists, update props
            if (bookingIndex > -1){
                Object.assign(state.bookings[bookingIndex], booking);
            } else {
                console.error("Failed to update local booking after response from API to an cancel request");
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })

const bookingStore = bookingApi.getStore();

// add selectedBooking to the store
(bookingStore.state as any).selectedBooking = 0
bookingStore.mutations.setSelectedBooking = (state, value) => {
  state.selectedBooking = value;
}
bookingStore.actions.setSelectedBooking = (context, value) => {
  context.commit("setSelectedBooking", value)
}

(bookingStore as any).namespaced = true;

export default bookingStore;
